import request from '@/utils/request'

const api = {
  list: '/api/retail/inventory/list',
  detail: '/api/retail/inventory/detail',
  init: '/api/retail/inventory/init',
  batchInit: '/api/retail/inventory/batchInit',
  batchReturn: '/api/retail/inventory/batchReturn',
  alarmList: '/api/retail/inventory/alarm/list',
  check: '/api/retail/inventory/check',
  deduct: '/api/retail/inventory/deduct',
  release: '/api/retail/inventory/release',
  initList: '/api/retail/inventory/init/list',
  initItemList: '/api/retail/inventory/init/item/list',
  auditInit: '/api/retail/inventory/init/audit',
  rejectInit: '/api/retail/inventory/init/reject',
  returnRecordList: '/api/retail/inventory/return/record/list',
  merchantList: '/api/retail/inventory/merchant/list',
  setPrice: '/api/retail/inventory/setPrice',
  goodsMerchantPrice: '/api/retail/inventory/goods/merchantPrice',
  storeList: '/api/retail/inventory/store/list',
  storePurchaseList: '/api/retail/inventory/storePurchase/list',
  storePurchaseExport: '/api/retail/inventory/storePurchase/export',
  createPurchaseOrder: '/api/retail/purchase/create',
  platformGoods: '/api/retail/purchase/platformGoods',
  storeReturn: '/api/retail/inventory/storeReturn',
  setGiftPoint: '/api/retail/inventory/setGiftPoint',
  platformPurchaseList: '/api/retail/inventory/platformPurchase/list',
  supplierList: '/api/retail/supplier/list/all/simple',
  lastPurchaseRecord: '/api/retail/inventory/lastPurchase',
  logList: '/api/retail/inventory/log/list',
  logByGoods: '/api/retail/inventory/log/byGoods',
  logByBiz: '/api/retail/inventory/log/byBiz'
}

export default api

export function getInventoryList(parameter) {
  return request({
    url: api.list,
    method: 'get',
    params: parameter
  })
}

export function getInventoryDetail(parameter) {
  return request({
    url: api.detail,
    method: 'get',
    params: parameter
  })
}

export function initInventory(parameter) {
  return request({
    url: api.init,
    method: 'post',
    params: parameter
  })
}

export function batchInitInventory(parameter) {
  return request({
    url: api.batchInit,
    method: 'post',
    data: parameter
  })
}

export function getAlarmList(parameter) {
  return request({
    url: api.alarmList,
    method: 'get',
    params: parameter
  })
}

export function checkStock(parameter) {
  return request({
    url: api.check,
    method: 'get',
    params: parameter
  })
}

export function deductStock(parameter) {
  return request({
    url: api.deduct,
    method: 'post',
    data: parameter
  })
}

export function releaseLockedStock(parameter) {
  return request({
    url: api.release,
    method: 'post',
    data: parameter
  })
}

export function getInitList(parameter) {
  return request({
    url: api.initList,
    method: 'get',
    params: parameter
  })
}

export function getInitItemList(parameter) {
  return request({
    url: api.initItemList,
    method: 'get',
    params: parameter
  })
}

export function batchReturnInventory(parameter) {
  return request({
    url: api.batchReturn,
    method: 'post',
    data: parameter
  })
}

export function getReturnRecordList(parameter) {
  return request({
    url: api.returnRecordList,
    method: 'get',
    params: parameter
  })
}

export function getMerchantInventoryList(parameter) {
  return request({
    url: api.merchantList,
    method: 'get',
    params: parameter
  })
}

export function setShopAndSalePrice(parameter) {
  return request({
    url: api.setPrice,
    method: 'post',
    data: parameter
  })
}

export function getGoodsMerchantPrice(parameter) {
  return request({
    url: api.goodsMerchantPrice,
    method: 'get',
    params: parameter
  })
}

export function getStoreInventoryList(parameter) {
  return request({
    url: api.storeList,
    method: 'get',
    params: parameter
  })
}

export function getStorePurchaseInventoryList(parameter) {
  return request({
    url: api.storePurchaseList,
    method: 'get',
    params: parameter
  })
}

export function exportStorePurchaseInventory(parameter) {
  return request({
    url: api.storePurchaseExport,
    method: 'get',
    params: parameter
  })
}

export function createPurchaseOrder(parameter) {
  return request({
    url: api.createPurchaseOrder,
    method: 'post',
    data: parameter
  })
}

export function getPlatformGoods(parameter) {
  return request({
    url: api.platformGoods,
    method: 'get',
    params: parameter
  })
}

export function storeReturnInventory(parameter) {
  return request({
    url: api.storeReturn,
    method: 'post',
    data: parameter
  })
}

export function setGiftPoint(parameter) {
  return request({
    url: api.setGiftPoint,
    method: 'post',
    data: parameter
  })
}

export function getPlatformPurchaseInventoryList(parameter) {
  return request({
    url: api.platformPurchaseList,
    method: 'get',
    params: parameter
  })
}

export function getSupplierList() {
  return request({
    url: api.supplierList,
    method: 'get'
  })
}

export function getLastPurchaseRecord() {
  return request({
    url: api.lastPurchaseRecord,
    method: 'get'
  })
}

export function auditInitRecord(parameter) {
  return request({
    url: api.auditInit,
    method: 'post',
    data: parameter
  })
}

export function rejectInitRecord(parameter) {
  return request({
    url: api.rejectInit,
    method: 'post',
    params: parameter
  })
}

// 采购退货相关接口
export function createReturnOrder(parameter) {
  return request({
    url: '/api/retail/inventory/return/create',
    method: 'post',
    data: parameter
  })
}

export function getReturnOrderList(parameter) {
  return request({
    url: '/api/retail/inventory/return/order/list',
    method: 'get',
    params: parameter
  })
}

export function getReturnItemList(parameter) {
  return request({
    url: '/api/retail/inventory/return/item/list',
    method: 'get',
    params: parameter
  })
}

export function auditReturnOrder(parameter) {
  return request({
    url: '/api/retail/inventory/return/audit',
    method: 'post',
    params: parameter
  })
}

export function rejectReturnOrder(parameter) {
  return request({
    url: '/api/retail/inventory/return/reject',
    method: 'post',
    params: parameter
  })
}

// 库存变动日志相关接口
export function inventoryLogList(parameter) {
  return request({
    url: api.logList,
    method: 'get',
    params: parameter
  })
}

export function inventoryLogByGoods(parameter) {
  return request({
    url: api.logByGoods,
    method: 'get',
    params: parameter
  })
}

export function inventoryLogByBiz(parameter) {
  return request({
    url: api.logByBiz,
    method: 'get',
    params: parameter
  })
}

















